import { render, staticRenderFns } from "./ShowLogPropertiesDetailsModal.vue?vue&type=template&id=2846102a&scoped=true&"
import script from "./ShowLogPropertiesDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ShowLogPropertiesDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846102a",
  null
  
)

export default component.exports